module.exports = __webpack_public_path__ + "static/media/onboard.9ff44c42.svg";